/**
 * Sign Up Form Handler
 * Handles password visibility toggle, password confirmation validation, and input clearing
 */

function initSignUpForm() {
  const signUpForm = document.querySelector('.sign-up-form');

  if (!signUpForm) {
    return;
  }

  // Helper function to show field error
  function showFieldError(input, message) {
    const fieldName = input.name;
    const errorElement = document.getElementById(`${fieldName}_error`);
    const inputWrapper = input.closest('.input-wrapper');
    
    if (errorElement) {
      errorElement.textContent = message;
      errorElement.classList.add('show');
      errorElement.style.color = '#DC2626'; // Ensure red color
    }
    
    if (inputWrapper) {
      input.classList.add('input-error');
    }
  }

  // Helper function to clear field error
  function clearFieldError(input) {
    const fieldName = input.name;
    const errorElement = document.getElementById(`${fieldName}_error`);
    
    if (errorElement) {
      errorElement.textContent = '';
      errorElement.classList.remove('show');
    }
    
    input.classList.remove('input-error');
  }

  // Password visibility toggle for both password fields
  const passwordToggles = signUpForm.querySelectorAll('.password-toggle');
  passwordToggles.forEach((toggle) => {
    const inputWrapper = toggle.closest('.input-wrapper');
    const passwordInput = inputWrapper.querySelector('input[type="password"], input[type="text"]');
    const eyeIcon = toggle.querySelector('.eye-icon');
    const eyeOffIcon = toggle.querySelector('.eye-off-icon');

    if (passwordInput && eyeIcon && eyeOffIcon) {
      toggle.addEventListener('click', function () {
        const isPassword = passwordInput.type === 'password';
        passwordInput.type = isPassword ? 'text' : 'password';

        if (isPassword) {
          eyeIcon.style.display = 'none';
          eyeOffIcon.style.display = 'block';
        } else {
          eyeIcon.style.display = 'block';
          eyeOffIcon.style.display = 'none';
        }
      });
    }
  });

  // Clear input buttons
  const clearButtons = signUpForm.querySelectorAll('.input-clear');
  clearButtons.forEach((button) => {
    button.addEventListener('click', function () {
      const inputWrapper = button.closest('.input-wrapper');
      const input = inputWrapper.querySelector('input, select');
      if (input) {
        input.value = '';
        if (input.type === 'password' || input.type === 'text') {
          input.focus();
        }
      }
    });
  });

  // Show/hide clear buttons and asterisks based on input value (exclude select dropdowns)
  const inputs = signUpForm.querySelectorAll('.input-wrapper input');
  inputs.forEach((input) => {
    const clearButton = input.closest('.input-wrapper').querySelector('.input-clear');
    const asterisk = input.closest('.input-wrapper').querySelector('.input-asterisk');
    const inputWrapper = input.closest('.input-wrapper');
    const hasLeftIcon = inputWrapper.querySelector('.input-icon-left');
    
    // Position asterisk after placeholder text
    function positionAsterisk() {
      if (asterisk && input.placeholder) {
        // Create a temporary span to measure placeholder text width
        const tempSpan = document.createElement('span');
        tempSpan.style.visibility = 'hidden';
        tempSpan.style.position = 'absolute';
        tempSpan.style.fontSize = window.getComputedStyle(input).fontSize;
        tempSpan.style.fontFamily = window.getComputedStyle(input).fontFamily;
        tempSpan.style.fontWeight = window.getComputedStyle(input).fontWeight;
        tempSpan.textContent = input.placeholder;
        document.body.appendChild(tempSpan);
        
        const textWidth = tempSpan.offsetWidth;
        document.body.removeChild(tempSpan);
        
        // Position asterisk based on whether there's a left icon
        if (hasLeftIcon) {
          // With icon: icon left (16px) + icon width (20px) + text width + gap
          const iconLeft = 16;
          const iconWidth = 20;
          const gap = 4;
          asterisk.style.left = `${iconLeft + iconWidth + textWidth + gap + 15}px`;
        } else {
          // Without icon: padding left (12px) + text width + gap
          const paddingLeft = 12;
          const gap = 4;
          asterisk.style.left = `${paddingLeft + textWidth + gap + 15}px`;
        }
      }
    }
    
    function toggleClearButton() {
      if (clearButton) {
        clearButton.style.display = input.value ? 'flex' : 'none';
      }
    }

    function toggleAsterisk() {
      if (asterisk) {
        // Show asterisk only when input is empty (placeholder is visible)
        asterisk.style.opacity = input.value ? '0' : '1';
      }
    }

    // Position asterisk on load and when window resizes
    positionAsterisk();
    window.addEventListener('resize', positionAsterisk);

    input.addEventListener('input', function() {
      toggleClearButton();
      toggleAsterisk();
    });
    input.addEventListener('focus', function() {
      toggleClearButton();
      toggleAsterisk();
    });
    input.addEventListener('blur', toggleAsterisk);
    
    toggleClearButton(); // Initial check
    toggleAsterisk(); // Initial check
  });

  // Password confirmation validation
  const passwordInput = signUpForm.querySelector('#password');
  const confirmPasswordInput = signUpForm.querySelector('#confirmPassword');

  function validatePasswordMatch() {
    if (confirmPasswordInput && passwordInput) {
      if (confirmPasswordInput.value && passwordInput.value !== confirmPasswordInput.value) {
        showFieldError(confirmPasswordInput, 'Passwords do not match');
      } else {
        clearFieldError(confirmPasswordInput);
      }
    }
  }

  if (passwordInput && confirmPasswordInput) {
    passwordInput.addEventListener('input', validatePasswordMatch);
    confirmPasswordInput.addEventListener('input', validatePasswordMatch);
  }

  // SMS Consent checkbox validation and submit button state
  const smsConsentCheckbox = signUpForm.querySelector('#smsConsent');
  const submitButton = signUpForm.querySelector('.btn-sign-up');
  
  function updateSubmitButtonState() {
    if (smsConsentCheckbox && submitButton) {
      submitButton.disabled = !smsConsentCheckbox.checked;
      if (!smsConsentCheckbox.checked) {
        submitButton.style.opacity = '0.6';
        submitButton.style.cursor = 'not-allowed';
      } else {
        submitButton.style.opacity = '1';
        submitButton.style.cursor = 'pointer';
      }
    }
  }

  if (smsConsentCheckbox) {
    smsConsentCheckbox.addEventListener('change', updateSubmitButtonState);
    // Initial state check
    updateSubmitButtonState();
  }

  // View more/less toggle for SMS consent text
  const viewMoreLink = signUpForm.querySelector('#view-more-link');
  const checkboxTextShort = signUpForm.querySelector('.checkbox-text-short');
  const checkboxTextFull = signUpForm.querySelector('.checkbox-text-full');
  
  if (viewMoreLink && checkboxTextShort && checkboxTextFull) {
    viewMoreLink.addEventListener('click', function(e) {
      e.preventDefault();
      
      const isExpanded = checkboxTextFull.style.display !== 'none';
      
      if (isExpanded) {
        // Collapse: show short text, hide full text
        checkboxTextShort.style.display = 'inline';
        checkboxTextFull.style.display = 'none';
        viewMoreLink.textContent = 'View more';
      } else {
        // Expand: hide short text, show full text
        checkboxTextShort.style.display = 'none';
        checkboxTextFull.style.display = 'inline';
        viewMoreLink.textContent = 'View less';
      }
    });
  }

  // Prevent digits in Firstname and Lastname fields
  const firstNameInput = signUpForm.querySelector('#firstName');
  const lastNameInput = signUpForm.querySelector('#lastName');
  
  function preventDigits(input) {
    input.addEventListener('input', function(e) {
      // Remove any digits from the input value
      const newValue = e.target.value.replace(/\d/g, '');
      if (e.target.value !== newValue) {
        e.target.value = newValue;
        // Trigger input event to update UI
        e.target.dispatchEvent(new Event('input', { bubbles: true }));
      }
      clearFieldError(input);
    });
    
    // Also prevent paste of digits
    input.addEventListener('paste', function(e) {
      e.preventDefault();
      const pastedText = (e.clipboardData || window.clipboardData).getData('text');
      const cleanedText = pastedText.replace(/\d/g, '');
      const currentValue = input.value;
      const selectionStart = input.selectionStart || 0;
      const selectionEnd = input.selectionEnd || 0;
      const newValue = currentValue.substring(0, selectionStart) + cleanedText + currentValue.substring(selectionEnd);
      input.value = newValue;
      input.setSelectionRange(selectionStart + cleanedText.length, selectionStart + cleanedText.length);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      clearFieldError(input);
    });
  }
  
  if (firstNameInput) {
    preventDigits(firstNameInput);
  }
  
  if (lastNameInput) {
    preventDigits(lastNameInput);
  }

  // Add blur validation for First Name field
  if (firstNameInput) {
    firstNameInput.addEventListener('blur', function() {
      if (!firstNameInput.value.trim()) {
        showFieldError(firstNameInput, 'Please input your first name');
      }
    });
  }

  // Add blur validation for Last Name field
  if (lastNameInput) {
    lastNameInput.addEventListener('blur', function() {
      if (!lastNameInput.value.trim()) {
        showFieldError(lastNameInput, 'Please input your last name');
      }
    });
  }

  // Phone validation helper function for US phone numbers
  function isValidUSPhoneNumber(phone) {
    if (!phone) return true; // Phone is optional
    const phoneNumber = phone.replace(/\D/g, ''); // Remove all non-digits
    
    // Must have exactly 10 digits
    if (phoneNumber.length !== 10) {
      return false;
    }
    
    // Area code (first 3 digits) cannot start with 0 or 1
    const areaCode = phoneNumber.substring(0, 3);
    if (areaCode[0] === '0' || areaCode[0] === '1') {
      return false;
    }
    
    // Exchange code (next 3 digits) cannot start with 0 or 1
    const exchangeCode = phoneNumber.substring(3, 6);
    if (exchangeCode[0] === '0' || exchangeCode[0] === '1') {
      return false;
    }
    
    return true;
  }

  // Add blur validation for Phone field
  const phoneInput = signUpForm.querySelector('#phone');
  if (phoneInput) {
    phoneInput.addEventListener('blur', function() {
      if (phoneInput.value.trim() && !isValidUSPhoneNumber(phoneInput.value)) {
        showFieldError(phoneInput, 'Please enter a valid US phone number');
      } else {
        clearFieldError(phoneInput);
      }
    });
    
    phoneInput.addEventListener('input', function() {
      clearFieldError(phoneInput);
    });
  }

  // Clear errors when user starts typing
  const allInputs = signUpForm.querySelectorAll('input');
  allInputs.forEach((input) => {
    // Skip firstName and lastName as they already have their own handlers
    if (input.id !== 'firstName' && input.id !== 'lastName' && input.id !== 'phone') {
      input.addEventListener('input', function() {
        clearFieldError(input);
      });
    }
  });

  // Form submission handler
  signUpForm.addEventListener('submit', async function (e) {
    e.preventDefault();

    // Clear previous errors
    const firstNameInput = signUpForm.querySelector('#firstName');
    const lastNameInput = signUpForm.querySelector('#lastName');
    const emailInput = signUpForm.querySelector('#email');
    const passwordInput = signUpForm.querySelector('#password');
    const confirmPasswordInput = signUpForm.querySelector('#confirmPassword');
    const phoneInput = signUpForm.querySelector('#phone');
    
    if (firstNameInput) clearFieldError(firstNameInput);
    if (lastNameInput) clearFieldError(lastNameInput);
    if (emailInput) clearFieldError(emailInput);
    if (passwordInput) clearFieldError(passwordInput);
    if (confirmPasswordInput) clearFieldError(confirmPasswordInput);
    if (phoneInput) clearFieldError(phoneInput);

    const formData = new FormData(signUpForm);
    const data = Object.fromEntries(formData);
    
    const firstName = data.firstName;
    const lastName = data.lastName;
    const email = data.email.trim();
    const phone = data.phone ? data.phone.trim() : null;
    const password = data.password;
    const confirmPassword = data.confirmPassword;
    const accountType = data.accountType || 'candidates';
    const refCode = data.refCode || null;
    const smsConsentCheckbox = signUpForm.querySelector('#smsConsent');
    const agreeToSms = data.smsConsent === 'on' || smsConsentCheckbox?.checked === true;

    // Basic validation
    let isValid = true;

    if (!firstName) {
      showFieldError(firstNameInput, 'Please input your first name');
      isValid = false;
    } else if (/\d/.test(firstName)) {
      showFieldError(firstNameInput, 'First name should not contain digits');
      isValid = false;
    }

    if (!lastName) {
      showFieldError(lastNameInput, 'Please input your last name');
      isValid = false;
    } else if (/\d/.test(lastName)) {
      showFieldError(lastNameInput, 'Last name should not contain digits');
      isValid = false;
    }

    if (!email) {
      showFieldError(emailInput, 'Please input your email');
      isValid = false;
    }

    if (!password) {
      showFieldError(passwordInput, 'Please input your password');
      isValid = false;
    }

    // Validate phone number if provided
    if (phone && !isValidUSPhoneNumber(phone)) {
      showFieldError(phoneInput, 'Please enter a valid US phone number');
      isValid = false;
    }

    // Validate password match
    if (passwordInput && confirmPasswordInput) {
      if (password !== confirmPassword) {
        showFieldError(confirmPasswordInput, 'Passwords do not match');
        isValid = false;
      }
    }

    // Validate SMS consent checkbox
    if (smsConsentCheckbox && !smsConsentCheckbox.checked) {
      alert('Please agree to receive SMS messages by checking the consent box.');
      smsConsentCheckbox.focus();
      isValid = false;
    }

    if (!isValid) {
      // Scroll to first error field
      const firstErrorField = signUpForm.querySelector('.input-error');
      if (firstErrorField) {
        firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
        firstErrorField.focus();
      }
      return;
    }

    const submitButton = signUpForm.querySelector('.btn-sign-up');
    const originalButtonText = submitButton.textContent;
    submitButton.disabled = true;
    submitButton.textContent = 'Signing up...';

    try {
      // Get API base URL from global scope (defined in main.js)
      const apiBaseUrl = typeof API_BASE_URL !== 'undefined' ? API_BASE_URL : (window.API_BASE_URL || 'https://api.electhq.net');
      
      // TEST MODE: Force error for testing error modal
      // Add ?testError=true to URL or set localStorage.setItem('testSignUpError', 'true')
      const urlParams = new URLSearchParams(window.location.search);
      const testError = urlParams.get('testError') === 'true' || localStorage.getItem('testSignUpError') === 'true';
      
      if (testError) {
        throw new Error('Test error: Simulated fetch failure for testing error modal');
      }
      
      const response = await fetch(`${apiBaseUrl}/admins/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email,
          password: password,
          first_name: firstName,
          last_name: lastName,
          phone: phone,
          account_type: accountType,
          ref_code: refCode,
          agree_to_sms: agreeToSms,
        }),
      });

      let responseData = {};
      const contentType = response.headers.get('content-type');
      if (contentType && contentType.includes('application/json')) {
        responseData = await response.json();
      }

      if (response.ok) {
        // Success: Registration successful, save email and password for verification
        sessionStorage.setItem('pendingVerificationEmail', email);
        sessionStorage.setItem('pendingVerificationPassword', password);
        
        // Redirect to verify email page
        window.location.href = 'verify-email.html';
      } else {
        // Handle errors
        const errorMessage = responseData?.message || 'Registration failed. Please try again.';
        alert(errorMessage);
      }
    } catch (error) {
      console.error('Registration error:', error);
      
      // Get API base URL for debug info
      const apiBaseUrl = typeof API_BASE_URL !== 'undefined' ? API_BASE_URL : (window.API_BASE_URL || 'https://api.electhq.net');
      
      // Use shared error modal utility
      if (typeof window.showErrorModal === 'function') {
        await window.showErrorModal(error, `${apiBaseUrl}/admins/register`, {
          title: 'Registration Error',
          message: 'An unexpected error occurred. Please try again.',
          additionalInfo: {
            formType: 'sign-up',
            email: email,
          },
        });
      } else {
        // Fallback if utility not loaded
        alert('An unexpected error occurred. Please try again.');
      }
      
    } finally {
      // Re-enable submit button
      submitButton.disabled = false;
      submitButton.textContent = originalButtonText;
    }
  });
}

// Export to window for global access
window.initSignUpForm = initSignUpForm;

